import './index.css';

// eslint-disable-next-line import/no-extraneous-dependencies
import { HeroUIProvider } from '@heroui/system';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ToastProvider } from '@heroui/toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import { ErrorBoundary } from './components';
import { BreadcrumbsProvider } from './context';
import reportWebVitals from './reportWebVitals';
import { App } from './views/App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router>
        <BreadcrumbsProvider>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
            <HeroUIProvider locale="pl-Pl">
              <ToastProvider
                toastOffset={20}
                placement="top-right"
              />
              <App />
            </HeroUIProvider>
          </QueryClientProvider>
        </BreadcrumbsProvider>
      </Router>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
